import React from 'react'

const WorkspacePage = () => {
  return (
    <div>WorkspacePage</div>
  )
}

export default WorkspacePage